define('rebrush/components/category/layered/filter',[
    'jquery',
    'lodash',
    'cartware/components/_base',
    'cartware/jquery/bem',
    'rebrush/system/layout/responsive-hub',
    'rebrush/system/animation',
    'modernizr' // shim
], function(
    $,
    _,
    Component,
    BEM,
    ResponsiveHub,
    Animation
) {
    var isMobile = true;

    var MODIFIER_OPEN       = 'open',
        MODIFIER_OPENING    = 'opening',
        MODIFIER_CLOSED     = 'closed';

    var endPrecedingAnimation = $.noop;

    return Component.create({
        block:			    null,
        trigger:            null,
        flyout:             null,
        flyoutWrap:         null,
        closeTrigger:       null,
        currentFilterBar:   null,
        submitButton:       null,

        originalButtonLabel:    null,
        isFilterSelectedOnLoad:   false,

        $init: function() {
            this.block = BEM.block('layered-nav-filter');
            this.trigger = this.block.getElements('wrapper-trigger');
            this.flyoutWrap = this.block.getElements('flyout');
            this.closeTrigger = this.block.getElements('trigger-close');
            this.flyout = BEM.block('layered-nav-flyout');
            this.currentFilterBar = BEM.block('layered-nav-current');
            this.submitButton = this.flyout.getElements('submit');
            this.form = this.submitButton.closest('form');
            this.priceSlider = BEM.block(this.block.find(BEM.block('layer-slider')));
            this.iconOpener = this.block.getElements('trigger-bar-icon');

            this.priceInputs = {
                original: {
                    min: this.priceSlider.find('.price-min'),
                    max: this.priceSlider.find('.price-max')
                },
                value: {
                    min: this.priceSlider.find('.price-value-min'),
                    max: this.priceSlider.find('.price-value-max')
                }
            };

            this.originalButtonLabel = this.submitButton.text();
            this.isFilterSelectedOnLoad = this.isFilterSelected();

            this._bindEvents();
            this.onFormChange();
        },

        _bindEvents: function() {
            this.trigger.on('click', _.bind(this.toggle, this));
            this.closeTrigger.on('click', _.bind(this.close, this));
            this.currentFilterBar.on('click', '.' + BEM.buildElementClassname('layered-nav-current', 'list-item'), _.bind(this.onActiveFilterClick, this));
            this.form.on('change', 'input[type="checkbox"]', _.bind(this.onCheckboxChange, this));
            this.form.on('change', _.bind(this.onFormChange, this));
            this.submitButton.on('click', _.bind(this.onSubmitButtonClick, this));

            ResponsiveHub
                .on('change.mobile.enter', function() { isMobile = true; })
                .on('change.mobile.leave', function() { isMobile = false; });
        },

        onFormChange: function() {
            var exitLabel = this.isFilterSelectedOnLoad ? this.submitButton.data('label-reset') : this.submitButton.data('label-close');
            this.submitButton.text(this.isFilterSelected() ? this.originalButtonLabel : exitLabel);
        },

        onCheckboxChange: function(e) {
            var checkbox = $(e.currentTarget),
                filterNode = checkbox.closest('[data-filter-id]'),
                filterId = filterNode.data('filter-id'),
                isBoolean = filterNode.data('boolean'),
                self = this;

            if (isBoolean) { // if this is a boolean or pseudo-boolean (yes/no select) attribute, uncheck other options
                this.flyout.find('[data-filter-id="' + filterId + '"]').not(filterNode).find('input[type="checkbox"]').each(function() {
                    self.setCheckboxChecked(this, false);
                });
            }
        },

        onSubmitButtonClick: function(e) {
            var self = this;

            if (!this.isFilterSelected()) {
                if (!this.isFilterSelectedOnLoad) {
                    e.preventDefault();
                    this.close();
                    return;
                }
            }
        },

        setCheckboxChecked: function(checkbox, checked) {
            checkbox = $(checkbox);
            var label = $('label[for="' + checkbox.attr('id') + '"]');

            if (checked) {
                checkbox.prop('checked', 'checked').addClass('checked');
                label.addClass('checked');
            } else {
                checkbox.prop('checked', false).removeClass('checked');
                label.removeClass('checked');
            }
        },

        isFilterSelected: function() {
            var formValues = _.filter(this.form.serializeArray(), function (item) { return item.name !== 'url' && item.value !== ''; });
            if (formValues.length > 0) {
                return true;
            }

            if (this.priceInputs.original.min.val() !== this.priceInputs.value.min.val()
                || this.priceInputs.original.max.val() !== this.priceInputs.value.max.val()
            ) {
                return true;
            }

            return false;
        },

        onActiveFilterClick: function(e) {
            var node = $(e.currentTarget),
                filterId = node.data('filter-id'),
                attributeId = node.data('attribute-id');

            if (filterId) {
                this.removeFilter(filterId, attributeId);
            }
        },

        removeFilter: function(filterId, attributeId) {
            var filterItem = this.flyout.getElements('filter-item'),
                form = filterItem.closest('form'),
                self = this;

            if (attributeId) {
                filterItem = filterItem.filter('[data-attribute-id="' + attributeId + '"]');
            }

            if ('*' !== filterId) {
                filterItem = filterItem.filter('[data-filter-id="' + filterId + '"]');
            }

            if (!filterItem.length) {
                return;
            }

            var typeActions = {
                'attribute': function(filterItem) {
                    var checkbox = filterItem.find('input[type=checkbox]');
                    self.setCheckboxChecked(checkbox, false);
                },

                'price': function(filterItem) {
                    var input = filterItem.find('.' + BEM.buildElementClassname('layer-slider', 'form-input'));

                    input.val('');
                }
            };

            typeActions.default = typeActions.attribute;

            filterItem.each(function() {
                var item = $(this),
                    filterType = filterItem.data('filter-type');

                if ('*' !== filterId) {
                    typeActions[filterType in typeActions ? filterType : 'default'](item);
                } else {
                    $.each(typeActions, function(filterType, typeAction) {
                        typeAction(item);
                    });
                }
            });

            form.submit();
        },

        toggle: function() {
            if (this.block.bemHasModifier(MODIFIER_OPEN)) {
                this.close();
            } else {
                this.open();
            }
        },

        open: function() {
            var targetHeight;
            var onAnimationEnd = _.bind(function() {
                endPrecedingAnimation = $.noop;
                this.flyoutWrap.css('height', '');
                this.block.bemRemoveModifier(MODIFIER_OPENING);
                this.block.bemAddModifier(MODIFIER_OPEN);
            }, this);

            this.block.bemAddModifier(MODIFIER_OPENING);
            this.iconOpener.bemAddModifier(MODIFIER_OPEN);
            this.iconOpener.bemRemoveModifier(MODIFIER_CLOSED);

            if (!isMobile && Animation.supportAnimations) {
                endPrecedingAnimation();
                endPrecedingAnimation = onAnimationEnd;
                this.flyoutWrap.css('height', 'auto');
                targetHeight = this.flyoutWrap.height();
                this.flyoutWrap.css('height', '');
                _.defer(_.bind(function() {
                    this.flyoutWrap.one(Animation.transitionEndEventName, onAnimationEnd);
                    this.flyoutWrap.css('height', targetHeight);
                }, this));
            } else {
                onAnimationEnd();
            }
        },

        close: function() {
            var onAnimationEnd = _.bind(function() {
                endPrecedingAnimation = $.noop;
                this.flyoutWrap.css('height', '');
                this.block.bemRemoveModifier(MODIFIER_OPEN);
            }, this);

            this.iconOpener.bemAddModifier(MODIFIER_CLOSED);
            this.iconOpener.bemRemoveModifier(MODIFIER_OPEN);

            if (!isMobile && Animation.supportAnimations) {
                endPrecedingAnimation();
                endPrecedingAnimation = onAnimationEnd;
                this.flyoutWrap.css('height', this.flyoutWrap.height());
                _.defer(_.bind(function() {
                    this.flyoutWrap.one(Animation.transitionEndEventName, onAnimationEnd);
                    this.flyoutWrap.css('height', 0);
                }, this));
            } else {
                onAnimationEnd();
            }
        }
    });
});

